module.exports = __webpack_public_path__ + "media/application/images/icons/mail_red-af08ff55675951bdcd58e101b9301e33.svg";